<template>
  <div class="yunxiao teacher member">
    <div v-if="memberOpened" class="member-opened">
      <van-icon name="checked" size="100" color="var(--c2)" />
      <h2>开通成功</h2>
      <p>复制链接，登录电脑端使用【会员积分】功能</p>
      <van-field
        center
        clearable
        readonly
        class="pc-link-filed"
      >

        <template #input>
          <input 
          type="text" 
          v-model="linkUrl" 
          readonly="readonly" 
          ref="copyInput"
          placeholder="请输入链接" 
          class="van-field__control">
        </template>
        <template #button>
          <van-button type="primary"  @click="copyUrl">复制</van-button>
        </template>
      </van-field>
    </div>
    <div v-else class="unopen-nav">
      <div class="main">
        <img src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0072.png">
        <div class="solgan-nav">
          <div class="solgan" v-for="solgan of solgans" :key="solgan.title">
            <div class="img" :style="{ backgroundImage: 'url(' + solgan.iconImg + ')' }"></div>
            <div class="content">
              <div class="sub-title">{{ solgan.title }}</div>
              <div class="details"><pre>{{ solgan.details }}</pre></div>
            </div>
          </div>
        </div>
        <div class="feature-section">
          <h1>开通立享四大功能</h1>
          <div class="solgan-nav">
            <div class="solgan" v-for="feature of features" :key="feature.title">
              <div class="img" :style="{ backgroundImage: 'url(' + feature.iconImg + ')' }"></div>
              <div class="content">
                <div class="details"><pre>{{ feature.title }}</pre></div>
              </div>
            </div>
          </div>        
        </div>
        <p class="tips">更多积分玩法，等你解锁</p>
      </div>
      <div class="footer">
        <van-button
          square round
          block
          type="primary"
          @click="submit"
          loading-text="保存中..."
          data-test="add-communication-page-btn-save"
        >
          立即开通
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageTitle: '会员积分',
      linkUrl: '',
      solgans: [
        {
          title: '促活',
          details: '增加课程互动性\n提升学员活跃度',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0073.png',
        },
        {
          title: '复购',
          details: '增强学员粘性\n提升续费率',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0074.png',
        },
        {
          title: '拉新',
          details: '提升品牌形象\n促进学员口碑宣传',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0075.png',
        },
      ],
      features: [
        {
          title: '会员等级',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0076.png',
        },
        {
          title: '会员权益',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0077.png',
        },
        {
          title: '会员日营销',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0078.png',
        },
        {
          title: '会员分析',
          iconImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0079.png',
        },
      ],
      user: app.teacher.user,
    }
  },
  computed: {
    memberOpened () {
      let { companyInfoVo } = this.user;
      return companyInfoVo && companyInfoVo.openProductCodeList && companyInfoVo.openProductCodeList.includes('MEMBER');
    },
    isAdmin () {
      let user = this.user;
      return user.admin || user.superAdmin;
    }
  },
  methods: {
    updateUserInfos () {
      this.$store.dispatch('queryUserInfo')
        .then(res => {
          this.user = res.userInfo;
        });     
    },
    copyUrl() {
      this.$refs.copyInput.select();
      this.$refs.copyInput.setSelectionRange(0, this.linkUrl.length);
      document.execCommand('copy');
      vant.Toast.success('复制成功');
      this.$refs.copyInput.blur();
    },
    submit () {
      if (!this.isAdmin) {
        this.$dialog
          .confirm({
            title: '无开通权限',
            message: '您没有开通【会员积分】功能权限，请联系管理员开通',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: '我知道了',
          })
          .catch(res => {
            // if (res === 'cancel')
          });        
        return false;
      }
      this.showLoading();
      this.$api.openMemberProduct()
        .then(res=> {
          if (res.code === 200) {
            this.$toast.success('操作成功');     
            this.updateUserInfos();       
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.linkUrl = location.origin + '/web/teacher/index.html' + location.search;
    if (process.env.VUE_APP_x3_env === 'prod') {
      this.linkUrl = `https://yunxiao.xiaogj.com/`;
    }
    this.updateUserInfos();  
  }
}
</script>

<style lang="scss" scoped>
.member-opened{
  padding: calc(var(--gap) * 40) 0 0;
  height: 100%;
  text-align: center;
  background-color: var(--white);
  >h2{
    margin: calc(var(--gap) * 8) 0 calc(var(--gap) * 40);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: var(--bold);
  }
  .pc-link-filed{
    margin: 0;
    padding: 0 calc(var(--gap) * 16);
    ::v-deep .van-field__body{
      padding-left: calc(var(--gap) * 16);
      height: calc(var(--w) * 44);
      background: var(--g1);
      border-radius: calc(var(--w) * 22);
      input{
        font-size: var(--fs-lg);
        &::selection {
            color: var(--g8);
            background: transparent;
        }
      }
      .van-field__button{
        .van-button--normal{
          height: calc(var(--w) * 44);
          border-radius: 0 calc(var(--w) * 22) calc(var(--w) * 22) 0;
        }
      }
    }
  }
}
.unopen-nav{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  div.main{
    flex: 1;
    overflow-y: auto;
    >img{
    margin: 0 0 0 0;
    width: 100%;
    }
    .solgan-nav{
      padding: calc(var(--gap) * 24) calc(var(--gap) * 12);
      display: flex;
      background-color: var(--white);
      .img{
        margin: 0 auto calc(var(--gap) * 8);
        width: calc(var(--w) * 48);
        height: calc(var(--w) * 48);
        background-size: calc(var(--w) * 48);
      }
      .solgan{
        flex: 1;
        text-align: center;
      }
      .content{
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        color: var(--g6);
        .sub-title{
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
          color: var(--g8);
          font-weight: var(--bold);
        }
      }
    }
    .feature-section{    
      margin: calc(var(--gap) * 12) 0 0;
      padding: calc(var(--gap) * 24) calc(var(--gap) * 12);
      background-color: var(--white);
      >h1{
        margin: 0 auto calc(var(--gap) * 24);
        text-align: center;
        font-size:var(--fs-ex2);
        line-height:var(--lh-ex2);
        font-weight: var(--bold);
      }
      >.solgan-nav{
        padding: 0;
        .img{
          width: calc(var(--w) * 40);
          height: calc(var(--w) * 40);
          background-size: cover;
        }
      }
    }
    .tips{
      margin: calc(var(--gap) * 12) 0;
      color: var(--g6);
      text-align: center;
    }
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: var(--cl-xs);
    }
  }
}
</style>
